import {
	LiveStreamDataState,
	SET_ALL_STAGES,
	SET_CURRENT_STAGE,
	SET_CURRENT_STREAM,
	SET_IS_EXPANDED,
} from "./types";

const setCurrentStreamType = (stage: any) => {
	const { id } = stage?.host_vendor || {};

	return {
		isTwitchStream: id == 1,
		isYoutubeStream: id == 3,
	};
};

// Define the reducer
export const liveStreamReducer = (
	state: LiveStreamDataState,
	action: any,
): LiveStreamDataState => {
	switch (action.type) {
		case SET_CURRENT_STAGE:
			return {
				...state,
				currentStage: action.payload,
				...setCurrentStreamType(action.payload),
			};
		case SET_ALL_STAGES:
			return {
				...state,
				allStages: action.payload,
				currentStage: action.payload[0],
				...setCurrentStreamType(action.payload[0]),
			};
		case SET_IS_EXPANDED:
			return {
				...state,
				isExpanded: action.payload,
			};
		case SET_CURRENT_STREAM:
			return {
				...state,
				currentStream: action.payload,
			};
		default:
			return state;
	}
};
